import { TASK_CONST } from '@/constant';
import {
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { FrameApi } from '@/type';
import { apiOf } from '@/util';

export const changeReviewer = apiOf<
  FrameApi.ChangeReviewer.Request,
  FrameApi.ChangeReviewer.Response
>(
  new AxiosPutRequestOptions<FrameApi.ChangeReviewer.Request>({
    url: '/v1/miri/task/:taskID/frame/-/reviewer',
    defaultData: {
      frameWorkState: 'Reviewing',
    },
  }),
);

export const upsertLabel = apiOf<
  FrameApi.UpsertLabel.Request,
  FrameApi.UpsertLabel.Response
>(
  new AxiosPostRequestOptions<FrameApi.UpsertLabel.Request>({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq',
    defaultData: {
      workState: 'Working',
    },
  }),
);

export const getDetail = apiOf<
  FrameApi.GetDetail.Request,
  FrameApi.GetDetail.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq',
  }),
);

export const getList = apiOf<
  FrameApi.GetList.Request,
  FrameApi.GetList.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/task/:pTaskID/frame' }));

export const getCount = apiOf<
  FrameApi.GetCount.Request,
  FrameApi.GetCount.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/task/:pTaskID/frame/count' }));

export const getHistoryList = apiOf<
  FrameApi.GetHistoryList.Request,
  FrameApi.GetHistoryList.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/task/:taskID/frame/:frameSeq/history',
  }),
);

export const updateWorkState = apiOf<
  FrameApi.UpdateWorkState.Request,
  FrameApi.UpdateWorkState.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq',
  }),
);

export const submit = apiOf<
  Omit<FrameApi.UpdateWorkState.Request, 'workState'>,
  FrameApi.UpdateWorkState.Response
>(
  new AxiosPutRequestOptions<FrameApi.UpdateWorkState.Request>({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq',
    defaultData: {
      workState: TASK_CONST.TASK_FRAME_WORKSTATE.REVIEW,
    },
  }),
);

export const review = apiOf<FrameApi.Review.Request, FrameApi.Review.Response>(
  new AxiosPostRequestOptions<FrameApi.Review.Request>({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq/review',
    defaultData: {
      workState: TASK_CONST.TASK_FRAME_WORKSTATE.REVIEWING,
    },
  }),
);

export const accept = apiOf<
  Omit<FrameApi.UpdateWorkState.Request, 'workState'>,
  FrameApi.UpdateWorkState.Response
>(
  new AxiosPutRequestOptions<FrameApi.UpdateWorkState.Request>({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq',
    defaultData: {
      workState: TASK_CONST.TASK_FRAME_WORKSTATE.DONE,
    },
  }),
);

export const reject = apiOf<
  Omit<FrameApi.UpdateWorkState.Request, 'workState'>,
  FrameApi.UpdateWorkState.Response
>(
  new AxiosPutRequestOptions<FrameApi.UpdateWorkState.Request>({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameSeq',
    defaultData: {
      workState: TASK_CONST.TASK_FRAME_WORKSTATE.REJECT,
    },
  }),
);

export const getNeighbor = apiOf<
  FrameApi.GetNeighbor.Request,
  FrameApi.GetNeighbor.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/task/:taskID/frame/:frameSeq/neighbor',
    defaultQuery: {
      mode: 'Worker',
    },
  }),
);

export const updateFrames = apiOf<
  FrameApi.UpdateFrames.Request,
  FrameApi.UpdateFrames.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/task/:pTaskID/frame',
  }),
);

export const requestFramePreAnnotation = apiOf<
  FrameApi.PreAnnotation.Request,
  FrameApi.PreAnnotation.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameID/preAnnotation',
  }),
);

export const requestSemiAnnotation = apiOf<
  FrameApi.SemiAnnotation.Request,
  FrameApi.SemiAnnotation.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/frame/:pFrameID/semiAnnotation',
  }),
);

export const updateWorkTime = apiOf<
  FrameApi.UpdateWorkTime.Request,
  FrameApi.UpdateWorkTime.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:taskID/frame/:frameSeq/worktime',
  }),
);
